import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { analyticsConfigured, getConsent, setConsent, loadAnalytics } from "@/lib/analytics";

export const ConsentBanner = () => {
  const [show, setShow] = useState(false);
  useEffect(() => {
    if (!analyticsConfigured) return;
    const c = getConsent();
    if (c === "granted") loadAnalytics();
    else if (!c) setShow(true);
  }, []);
  if (!show) return null;
  const choose = (v) => { setConsent(v); setShow(false); };
  return (
    <div className="fixed inset-x-4 bottom-24 z-[56] mx-auto max-w-xl rounded-2xl border border-white/10 bg-[#0E1526]/95 p-5 text-sm text-slate-200 backdrop-blur-xl sm:bottom-6" data-testid="consent-banner">
      <p>We use Google Analytics cookies to understand how visitors use our website. See our <Link to="/privacy-policy" className="text-[#00F0FF] underline">Privacy Policy</Link>.</p>
      <div className="mt-4 flex gap-3">
        <button onClick={() => choose("granted")} className="rounded-full bg-[#00F0FF] px-4 py-2 font-semibold text-[#070B14]" data-testid="consent-accept">Accept</button>
        <button onClick={() => choose("denied")} className="rounded-full border border-white/20 px-4 py-2" data-testid="consent-decline">Decline</button>
      </div>
    </div>
  );
};
